import {Component} from "react";
import {withRouter} from "react-router-dom";
import {connect} from 'react-redux';
import withFormHanlding from "../../hoc/FormHandling";
import Settings from "../screens/Settings";
import {saveSettings} from "../../reducers/app";
import store from "../../localStorage";
import apiApp from "../../api/apiApp";

class SettingsContainer extends Component {
    constructor(props) {
        super(props);
    }

    componentDidMount() {
        let formState = {
            formErrors: {
                server_host: [],
                window_name: [],
            },
            formValues: {...this.props.settings},
            formValid: false,
            onSubmit: this.onSubmit
        };

        this.props.prepareFormState(formState)
        .then(() => {
            this.props.validateField(document.getElementById('server_host'));
            this.props.validateField(document.getElementById('window_name'));
        })
    }

    onChange = (e) => this.props.validateField(e.target);

    handleSubmit = () => {
        apiApp.getSettings();
        if (this.props.formValid) {
            saveSettings(store.dispatch, this.props.formValues);
            document.location.href = "/";
        }
        return false;
    }

    render() {
        return <Settings onChange={this.onChange} handleSubmit={this.handleSubmit} {...this.state} {...this.props} />
    }
}

const mapStateToProps = (store) => {
    return {
        load: store.loadState,
        settings: store.appState.settings,
    };
};

export default withRouter(connect(mapStateToProps)(withFormHanlding(SettingsContainer)));